// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ic-0";
export var fulfillmentPanelBody = "_ic-1";